// LogoutButton.js
import React from "react";

const LogoutButton = ({ onLogout }) => {
  const handleLogout = () => {
    window.FB.getLoginStatus((response) => {
      if (response.status === "connected") {
        window.FB.logout(() => {
          localStorage.removeItem("facebookUser");
          localStorage.removeItem("facebookAccessToken");
          localStorage.removeItem("facebookPageAccessToken");
          onLogout();
        });
      } else {
        onLogout();
      }
    });
  };

  return (
    <button
      onClick={handleLogout}
      className="bg-red-500 text-white px-4 py-2 rounded transition duration-300 hover:bg-red-600"
    >
      Logout
    </button>
  );
};

export default LogoutButton;
